export default __webpack_public_path__ + "static/media/IMG_5092.7bb391c1.png";